import { SectionButtonStatus } from 'lib/SectionButton/SectionButton.types';
import { DirectSalesAllocationSolutionStatus } from 'components/common/types/DirectSalesAllocationSolution';

const SECTION_BUTTON_STATUSES = {
  [DirectSalesAllocationSolutionStatus.RED]: SectionButtonStatus.RED,
  [DirectSalesAllocationSolutionStatus.ORANGE]: SectionButtonStatus.ORANGE,
  [DirectSalesAllocationSolutionStatus.GREEN]: SectionButtonStatus.GREEN,
};

export const getSectionButtonStatus = (
  objectiveStatus?: DirectSalesAllocationSolutionStatus,
): SectionButtonStatus | undefined => {
  if (!objectiveStatus) return undefined;

  return SECTION_BUTTON_STATUSES[objectiveStatus];
};
